// utils/redux/inventoryTransaction/inventoryTransactionSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    transactions: [],
    total: 0,
    page: 1,
    pages: 1,
    summary: {
        totalIn: 0,
        totalOut: 0,
        totalValue: 0,
        transactionCount: 0
    },
    runningBalance: 0,
    adjustmentSummary: [],
    isLoading: false,
    error: null
};

const inventoryTransactionSlice = createSlice({
    name: "inventoryTransaction",
    initialState,
    reducers: {
        setTransactions: (state, action) => {
            state.transactions = action.payload.data || [];
            state.total = action.payload.pagination?.total || 0;
            state.page = action.payload.pagination?.page || 1;
            state.pages = action.payload.pagination?.pages || 1;
            state.summary = action.payload.summary || state.summary;
            state.runningBalance = action.payload.runningBalance || 0;
            state.adjustmentSummary = action.payload.adjustmentSummary || [];
        },
        addTransaction: (state, action) => {
            state.transactions.unshift(action.payload);
            state.total += 1;
        },
        updateTransaction: (state, action) => {
            const index = state.transactions.findIndex(
                (item) => item._id === action.payload._id
            );
            if (index !== -1) {
                state.transactions[index] = action.payload;
            }
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        }
    }
});

export const {
    setTransactions,
    addTransaction,
    updateTransaction,
    setLoading,
    setError,
    clearError
} = inventoryTransactionSlice.actions;

export const InventoryTransactionReducer = inventoryTransactionSlice.reducer;